// src/service/authService.js

import { axios, authAxios } from './axiosService'; // Use 'axios' instead of 'axiosService'
import axiosOriginal from 'axios';

// src/service/authService.js

export const getTokenFromCode = async (codeStr) => {
  try {
    // Use a different base URL for this specific call
    const AuthBaseUrl = process.env.REACT_APP_NEW_LOGIN_AUTH_URL;
    const apiUrl = `${AuthBaseUrl}/auth/v1/loginToken/${codeStr}&redirect=${process.env.REACT_APP_NEW_LOGIN_REDIRECT_URL}`;

    // Use original axios (not your configured axiosService)
    const res = await axiosOriginal.get(apiUrl);

    return res?.data;
  } catch (error) {
    console.error('getTokenFromCode error:', error);
    throw error;
  }
};

export const getUserInfo = async () => {
  try {
    const token = window.localStorage.getItem('accessToken');
    if (!token) {
      return null;
    }

    const res = await authAxios.get('/auth/v1/validateLoginToken');
    return res;
  } catch (ex) {
    console.error('Error getting user info:', ex);
    return null;
  }
};

export const logoutRequest = () => {
  return axios.get(`/auth/v1/logout`);
};

export const postUserTimeZoneInfo = (email) => {
  if (!email) return Promise.resolve(null);

  return authAxios.post('/api/v2/userLoginInfo', {
    email,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });
};

export const register = (data) => {
  return axios.post(
    `${process.env.REACT_APP_DD_service_url}/auth/registration`,
    { ...data },
  );
};

export const getMAToken = () => {
  return axios.get(`/api/magateway/token`);
};

export const requestAccess = (userInfo, requestApp, reason) => {
  return axios.post(
    `/api/v2/requestAccess`,
    Object.keys(userInfo)
      .filter((k) => ['uid', 'name', 'email'].indexOf(k) !== -1)
      .reduce((acc, k) => Object.assign(acc, { [k]: userInfo[k] }), {
        app: requestApp,
        requestReason: reason,
      }),
  );
};

export const getPrmssns = () => {
  return axios.get(`/api/v2/getPermAndPendingAccessInfo`);
};

export const getAllProjectCount = () => {
  return axios.get('/api/v2/getToolsProjectInfo');
};

export const getAcceptTermsRequest = async (uid) => {
  const accessToken =
    window.localStorage?.getItem('accessToken') ||
    window.localStorage.getItem('accessToken');
  const refreshToken =
    window.localStorage?.getItem('refreshToken') ||
    window.localStorage.getItem('refreshToken');

  return axios.get(
    `${process.env.REACT_APP_DD_service_url}/auth/acceptTermsOfUse/${uid}`,
    {
      headers: {
        authorization: accessToken,
        refreshToken: refreshToken,
      },
    },
  );
};

export const setAcceptTermsRequest = async (uid) => {
  const accessToken =
    window.localStorage?.getItem('accessToken') ||
    window.localStorage.getItem('accessToken');
  const refreshToken =
    window.localStorage?.getItem('refreshToken') ||
    window.localStorage.getItem('refreshToken');

  return axios.post(
    `${process.env.REACT_APP_DD_service_url}/auth/acceptTermsOfUse/${uid}`,
    { data: 'true' },
    {
      headers: {
        authorization: accessToken,
        refreshToken: refreshToken,
      },
    },
  );
};

export const getTheme = () => {
  return axios.get('/public/v1/config/theme');
};
